<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
	<rect x="1" y="5" width="10" height="1" />
</svg>
</template>